<script>
	import BatchData from "../../Batch/index.svelte";
	import CompanyInfo from "../../Company/Info/index.svelte";
	import UserInfo from "../../User/UserInfo/index.svelte";
	import CompanyProducts from "../../Company/Products/index.svelte";
	import DataAnalysis from "../../Data/DataAnalysis/index.svelte";

	export let navSelected = '';

	export let colabList = null;

	export let batchFilter = null;

	export let addNewBatch = null;

</script>

	<div class="midContainer">	
		{#if navSelected == 0} <!-- Company Info  --> 

			<CompanyInfo bind:colaboratorsList={colabList}/>
		{:else if navSelected == 1} <!-- Products  -->
			<CompanyProducts/>
		{:else if navSelected == 2} <!--Batch Data -->

			<BatchData bind:addNewBatch={addNewBatch} batchFilter={batchFilter}/>

		{:else if navSelected == 3} <!-- User Info  -->
			<UserInfo/>
		{:else if navSelected == 4} <!-- Data Analysis  -->
			<DataAnalysis/>
		{:else}
			<div>Error</div>
		{/if}
	</div>



<style>
	
	/*.topContainer{
		width: 100%;
		height: 9%;
		box-shadow: 1.4rem 0.08rem white;
		display: none;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 10%;
		background-color: black;
	}*/

	.midContainer{
		width: 100%;
		height: 100%;
	}

	/*.botContainer{
		width: 100%;
		height: 9%;
	}*/

</style>